// tslint:disable
export var EnrollmentSendTo;
(function (EnrollmentSendTo) {
    // Unknown location. Not a valid choice
    EnrollmentSendTo[EnrollmentSendTo["Unknown"] = 0] = "Unknown";
    // Send enrollment data to HealthSmart via Medical Activation Service
    EnrollmentSendTo[EnrollmentSendTo["MedicalActivationServiceHealthSmart"] = 1] = "MedicalActivationServiceHealthSmart";
})(EnrollmentSendTo || (EnrollmentSendTo = {}));
EnrollmentSendTo['UNKNOWN'] = 0;
EnrollmentSendTo['MEDICALACTIVATIONSERVICEHEALTHSMART'] = 1;
//# sourceMappingURL=EnrollmentSendTo.js.map